import { Entity, makeClone } from 'gossamer-unified';
import { PaymentSummaryView } from './PaymentSummaryView';

export interface PaymentAnnualSummaryViewRow {
  institution_id: number;
  user_id: string;
  paid_pending_bookings: number;
  paid_pending_amount: number;
  paid_out_bookings: number;
  paid_out_amount: number;
  refunded_net_bookings: number;
  refunded_net_amount: number;
  refunded_gross_bookings: number;
  refunded_gross_amount: number;
  not_refunded_bookings: number;
  not_refunded_amount: number;
}

const clone = makeClone();

export const PaymentAnnualSummaryView: Entity<PaymentAnnualSummaryViewRow> = {
  id: 'PaymentAnnualSummaryView',
  title: 'Payments',
  service: 'main',
  rowLabel: (row: PaymentAnnualSummaryViewRow) => [row.institution_id, row.user_id].join(' / '),
  primaryKeyFields: ['institution_id', 'user_id'],
  source: {
    tableName: 'public.payment_annual_summary_view',
  },
  security: PaymentSummaryView.security,
  fields: {
    user_id: clone(PaymentSummaryView.fields.user_id),
    institution_id: clone(PaymentSummaryView.fields.institution_id),
    paid_pending_bookings: clone(PaymentSummaryView.fields.paid_pending_bookings),
    paid_pending_amount: clone(PaymentSummaryView.fields.paid_pending_amount),
    paid_out_bookings: clone(PaymentSummaryView.fields.paid_out_bookings),
    paid_out_amount: clone(PaymentSummaryView.fields.paid_out_amount),
    refunded_net_bookings: clone(PaymentSummaryView.fields.refunded_net_bookings),
    refunded_net_amount: clone(PaymentSummaryView.fields.refunded_net_amount),
    refunded_gross_bookings: clone(PaymentSummaryView.fields.refunded_gross_bookings),
    refunded_gross_amount: clone(PaymentSummaryView.fields.refunded_gross_amount),
    not_refunded_bookings: clone(PaymentSummaryView.fields.not_refunded_bookings),
    not_refunded_amount: clone(PaymentSummaryView.fields.not_refunded_amount),
  },
};
